module.exports = "/_next/static/resources/pack-fe79afd79c95f73ba095a5a9dc11859f.jpg";